/**
 * product
 */
export default {
  namespaced: true,
  state: {
    product: null
  },
    
  mutations: {
    SET_PRODUCT (state, value) {
      state.product = value
    }
  },
  getters: {
    cinema: (state) => state.product
  }
}
